export const NBN_ORDER_STATUS = {
  DRAFT: 'DRAFT', // start of the journey
  CONFIRMED: 'CONFIRMED', // user has accepted the terms and conditions
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED', // successful payment
  PAYMENT_FAILED: 'PAYMENT_FAILED', // unsuccessful paymnent
  SUBMITTED: 'SUBMITTED', // Sign up journey finished
  COMPLETED: 'COMPLETED',
  ACTIVATED: 'ACTIVATED',
  ACTIVATION_FAILED: 'ACTIVATION_FAILED'
} as const;

export enum NBN_REQUEST_TYPE {
  CREATE_ORDER = 'CREATE_ORDER',
  ADD_MODEM = 'ADD_MODEM',
  DELETE_PROMOTION = 'DELETE_PROMOTION',
  APPLY_PROMOTION = 'APPLY_PROMOTION'
}

export enum DELIVERY_ADDRESS_TYPE {
  SEARCH = 'SEARCH',
  DEFAULT = 'DEFAULT',
  MANUAL = 'MANUAL'
}

export enum SERVICE_SETUP_OPTION {
  OPTION_YES = 'OWNED',
  OPTION_NO = 'NOT_OWNED'
}
export enum CONNECTION_BOX_OPTIONS {
  YES = 'FOUND',
  NO = 'NOT_FOUND',
  UNSURE = 'UNSURE'
}

export enum CONNECTION_DATE_OPTION {
  ASAP = 'ASAP',
  SPECIFIC_DATE = 'SPECIFIC_DATE'
}

export enum DELIVERY_ADDRESS_OPTION {
  EXISTING = 'EXISTING',
  OLD = 'OLD',
  ANOTHER = 'ANOTHER'
}

/**
 * This is the payment option enum for the API, in case of BYO modem,
 * the API treats it as if no modem is selected as BYO is not a product
 */
export enum NBN_PAYMENT_OPTION {
  UPFRONT = 'UPFRONT',
  MONTH_BY_MONTH = 'MONTH_BY_MONTH',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export enum BINARY_STATUS {
  YES = 'YES',
  NO = 'NO'
}

export enum NBN_SERVICE_STATUS {
  PHONE_INTERNET = 'PHONE_INTERNET',
  INTERNET = 'INTERNET',
  UNKNOWN_NUMBER = 'UNKNOWN_NUMBER',
  NO_SERVICE = 'NO_SERVICE'
}

export enum NTD_STATUS {
  FOUND = 'FOUND',
  NOT_FOUND = 'NOT_FOUND',
  UNSURE = 'UNSURE'
}

export enum NOTIFICATION_CHANNEL {
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export enum PAYMENT_STATUS {
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_CAPTURE_FAILED = 'PAYMENT_CAPTURE_FAILED'
}

export enum VALIDATION_RESULT {
  PROCEED = 'PROCEED',
  PENDING_ORDER = 'PENDING_ORDER',
  ACTIVE_SERVICE = 'ACTIVE_SERVICE'
}

export enum ACTIVATION_ERROR_CODE {
  PENDING_ORDER = 'PENDING_ORDER'
}
